var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "square",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.95115,0,0,0.882427,-0.344977,0.255728)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.671,
    y: 4.243,
    width: 6.308,
    height: 1.133,
    style: {
      strokeWidth: "0.54px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.95115,0,0,0.882427,-0.344977,3.25573)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.671,
    y: 4.243,
    width: 6.308,
    height: 1.133,
    style: {
      strokeWidth: "0.54px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.83283,0,0,0.882427,-6.04069,15.2557)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.671,
    y: 4.243,
    width: 6.308,
    height: 1.133,
    style: {
      strokeWidth: "0.35px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.266,10.586L13.204,13.649L11.187,11.632L11.18,11.639L11.089,11.549L6.582,16.056L7.29,16.763L11.096,12.956L13.133,14.992L13.147,14.978L13.218,15.049L16.969,11.298L16.969,12.113L17.969,12.113L17.969,10.586L17.97,10.586L17.97,9.586L17.969,9.586L17.969,9.585L16.969,9.585L16.969,9.586L15.442,9.586L15.442,10.586L16.266,10.586Z",
    style: {
      strokeWidth: "0.5px"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.960887,0,0.521121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.485,6.066L15.375,-0.005L2.468,-0.005L2.468,23.984L21.485,23.984L21.485,6.066ZM14.453,7.193C14.096,6.836 14.071,6.361 14.071,6.361L14.07,1L3.5,1L3.5,23L20.5,23L20.5,7.454L15.563,7.541C15.563,7.541 14.81,7.549 14.453,7.193ZM15.629,5.952C15.877,6.147 16.314,6.089 16.314,6.089L19.479,6.08L15.4,2.105L15.41,5.311C15.41,5.311 15.353,5.735 15.629,5.952Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.985,6.066C21.985,5.924 21.929,5.788 21.83,5.69L15.72,-0.381C15.627,-0.474 15.503,-0.525 15.375,-0.525L2.468,-0.525C2.192,-0.525 1.968,-0.292 1.968,-0.005L1.968,23.984C1.968,24.272 2.192,24.505 2.468,24.505L21.485,24.505C21.761,24.505 21.985,24.272 21.985,23.984L21.985,6.066ZM21.485,6.066L15.375,-0.005L2.468,-0.005L2.468,23.984L21.485,23.984L21.485,6.066ZM14.453,7.193C14.096,6.836 14.071,6.361 14.071,6.361L14.07,1L3.5,1L3.5,23L20.5,23L20.5,7.454L15.563,7.541C15.563,7.541 14.81,7.549 14.453,7.193ZM15.549,8.062L20,7.984C20,7.984 20,22.48 20,22.48C20,22.48 4,22.48 4,22.48C4,22.48 4,1.52 4,1.52C4,1.52 13.57,1.52 13.57,1.52C13.57,1.52 13.571,6.361 13.571,6.361L14.071,6.881C14.071,6.881 13.572,6.391 13.572,6.391C13.572,6.391 13.573,6.404 13.575,6.423C13.585,6.535 13.658,7.119 14.107,7.568C14.31,7.772 14.599,7.904 14.879,7.975C15.191,8.054 15.481,8.061 15.549,8.062ZM16.283,6.092C16.179,6.101 15.837,6.116 15.629,5.952C15.353,5.735 15.41,5.311 15.41,5.311L15.4,2.105L19.479,6.08L16.314,6.089L16.314,6.089L16.313,5.569C16.313,5.569 18.217,5.563 18.217,5.563C18.217,5.563 15.904,3.309 15.904,3.309L15.91,5.309C15.91,5.331 15.909,5.353 15.906,5.374L15.906,5.374C15.906,5.374 15.902,5.433 15.912,5.484C15.916,5.501 15.914,5.524 15.93,5.537C15.969,5.568 16.025,5.567 16.071,5.572C16.156,5.581 16.252,5.573 16.252,5.573L16.283,6.092Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/reports-icon.46e9ae91.svg";
export { ForwardRef as ReactComponent };